import Cookies from "js-cookie";
import requestHandler from "./requestHandler";

let csrfRefreshPromise = null;
export default {
    getCRSF(fetchNewXsrfToken = false) {
      if(csrfRefreshPromise) return csrfRefreshPromise;
      if(fetchNewXsrfToken || !Cookies.get('XSRF-TOKEN')) {
        csrfRefreshPromise = requestHandler.get("sanctum/csrf-cookie", { timeout: 10000 })
          .finally(() => { csrfRefreshPromise = null; });
        return csrfRefreshPromise;
      }
    }
};
